module.exports = __webpack_public_path__ + "img/fen-open.e5a08dc4.svg";